import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';

const WeekPickerDay = (
  props: PickersDayProps & {
    selectedDay?: DateTime | null;
    hoveredDay?: DateTime | null;
    onPointerEnter?: (day: DateTime) => void;
    onPointerLeave?: () => void;
  },
) => {
  const { selectedDay, hoveredDay, onPointerEnter, onPointerLeave, day, ...other } = props;

  const isSelected =
    selectedDay && day >= selectedDay.startOf('week') && day <= selectedDay.endOf('week');
  const isHovered =
    hoveredDay && day >= hoveredDay.startOf('week') && day <= hoveredDay.endOf('week');
  const isCurrentDay = day.hasSame(DateTime.local(), 'day');

  return (
    <PickersDay
      {...other}
      day={day}
      selected={!!isSelected}
      onPointerEnter={() => onPointerEnter?.(day)}
      onPointerLeave={onPointerLeave}
      sx={{
        ...(isCurrentDay && {
          backgroundColor: '#ffffff !important',
          border: '1px solid rgba(25, 118, 210, 1) !important',
          color: 'var(--primary-color) !important',
          '&:hover': {
            backgroundColor: '#ffffff !important',
          },
        }),
        ...(isCurrentDay &&
          isSelected && {
            backgroundColor: '#ffffff !important',
            border: '1px solid rgba(25, 118, 210, 1) !important',
          }),
        ...(isSelected &&
          !isCurrentDay && {
            borderRadius: '50%',
            backgroundColor: 'rgba(25, 118, 210, 0.12)',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.16)',
            },
          }),
        ...(isHovered &&
          !isSelected && {
            borderRadius: '50%',
            backgroundColor: 'rgba(25, 118, 210, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(25, 118, 210, 0.12)',
            },
          }),
      }}
    />
  );
};

export { WeekPickerDay };
